import React, { Fragment } from 'react';
import {
  Page,
  Navbar,
  NavTitle,
} from 'framework7-react';

class Website extends React.Component {
  constructor(props) {
    super(props);
    var page = props.f7route.params.page;

    this.state = {
      page: page,
      pageTitle: page == 'about' ? 'About Easychaw' : page == 'faq' ? 'Frequently Asked Questions' : page == 'how' ? 'How To Videos' : 'Website'
    };
  }

  render() {
    return (
    <Page id="website-page">
        <Navbar sliding={false} backLink="Back">
            <NavTitle sliding> {this.state.pageTitle}</NavTitle>
        </Navbar>
        <iframe
        src={`https://www.easychaw.com/${this.state.page}.php#app`}
        style={{
            height: '100%',
            width: '100%',
            border: 'none',
            position: 'relative',
            zIndex: '1',
        }}></iframe>
    
        {/* Background */}
        <div
            style={{
            position: 'absolute',
            top: 0,
            left: 0,
            padding: 0,
            width: '100%',
            margin: 0,
            height: '100%',
            backgroundColor: '#fdfdfd',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            zIndex: 0,
            }}>
            <img 
                src="static/easychaw.gif" 
                style={{
                    position: 'absolute',
                    zIndex: 0,
                    width: '100%',
                    objectFit: 'scale-down',
                    display: 'flex',
                    alignSelf: 'center',
                    justifySelf: 'center',
                    height: '100%',
                }}
            />
        </div>
    </Page>
    );
  }

  onPageAfterIn() {
    const self = this;
  }
}



export default Website;
